export default "__VITE_ASSET__DZuJzdh2__"